import MaterialTable from 'material-table'
import React, { useContext, useEffect, useState } from 'react'
import tableIcons, { options } from 'components/universal/table_attributes'
import {
    Typography,
    Paper,
    IconButton,
    Menu,
    MenuItem, Box,
    TextField
} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import ReportProblemIcon from "@material-ui/icons/ReportProblem";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import VisibilityIcon from '@material-ui/icons/Visibility';
import EditIcon from '@material-ui/icons/Edit';
import { ICON_COLOUR } from 'lib/constants/style_constants';
import PartSalesServices from 'lib/services/api/commercial/parts';
import { format24HrDateOnly, getColors, getOrganisationId } from 'lib/utils/common_utils';
import CommercialIcon from 'assets/Commercial/Sales'
import TickIcon from 'assets/Commercial/Tick'
import RedCrossIcon from 'assets/Red remove icon.png'
import CheckIcon from "@material-ui/icons/Check";
import CloseIcon from "@material-ui/icons/Close";
import MROTextField from 'components/form_components/TextField';

import Receipt from './Receipt';
import TraceDocuments from './TraceDocuments';
import PartSales from 'views/Accounts/PartSales';
import { ToastMessageContext } from 'lib/contexts/message_context';
import TabDetails from 'views/Operations/Workshop/TabDetails';
import { MaintenanceServices } from 'lib/services/api/operaitons/WorkShop/TaskLibrary/Maintenance/maintenance_operation';
import Files from 'views/Accounts/PartSales/Sales/Files';

export default function SelectedCoreDetails(props) {

    const { tab, currentSelection, getCoreTableDetails, coreDetails, setIsRefreshTable, coreLoading, writePermission } = props
    const [data, setData] = useState([])

    const [traceData, setTraceData] = useState([])
    const [loading, setLoading] = useState(null)
    const [editingRowId, setIsEditRowId] = useState(null)
    const [repairData, setRepairData] = useState([
    ])
    const [editTrace, setEditTrace] = useState("")
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedRow, setSelectedRow] = useState(null);
    const [action, setAction] = useState(null)
    const message = useContext(ToastMessageContext)
    const [isEditable, setIsEditable] = useState(false)
    const [releaseDocuments, setReleaseDocuments] = useState({})
    const [parentState, setParentState] = useState({})
    const [workshopOrderDetails, setWorkshopOrderDetails] = useState({})
    const fetchData = async () => {
        if (!currentSelection) return;

        setLoading(true);
        const receiptParams = {
            organisation_id: getOrganisationId(),
            id: currentSelection.id,
        };
        const traceParams = {
            organisation_id: getOrganisationId(),
            sales_order_core_id: currentSelection.id,
        };
        const repairParams = {
            organisation_id: getOrganisationId(),
            sales_core_id: currentSelection.id,
        };

        try {
            const [receiptRes, traceRes, repairRes] = await Promise.all([
                PartSalesServices.getReceiptDetails(receiptParams),
                PartSalesServices.getSubTraceDetails(traceParams),
                PartSalesServices.getSubRepairDetails(repairParams)
            ]);
            setParentState(receiptRes)
            const receiptData = [receiptRes] || [];
            const traceData = traceRes?.data || [];
            const repairData = [repairRes] || []
            if (repairRes) {
                getReleaseDocuments(repairRes)
            }
            setData(receiptData);
            setTraceData(traceData)
            setRepairData(repairData)
            // Or use a custom merge
        } catch (error) {
            console.error("Error fetching data:", error);
        } finally {
            setLoading(false);
            setIsRefreshTable(false)
        }
    };






    useEffect(() => {
        if (currentSelection !== undefined) {
            fetchData();
        }
    }, [currentSelection, coreLoading])

    const refreshTable = () => {
        setAction(null)
        fetchData()
        getCoreTableDetails()
        setIsRefreshTable(true)
    }
    const renderStateIcon = (rowData) => {

        const Icon = {
            0: <CommercialIcon fill={getColors("amber")} />,
            1: <TickIcon fill={getColors("green")} />,
            2: <img src={RedCrossIcon} height={'20px'} />,


        }

        return Icon[rowData?.status]

    }

    const canEditTraceFee =
        selectedRow?.status === 2 &&
        [0, 1].includes(parentState?.parent_status) && writePermission;

    const canMarkReceived =
        [0, 2].includes(selectedRow?.status) &&
        [0, 1].includes(parentState?.parent_status) && writePermission;

    const canMarkNotReceived =
        [0, 1].includes(selectedRow?.status) &&
        [0, 1].includes(parentState?.parent_status) && writePermission;




    const handleMenuOpen = (event, rowData) => {
        setAnchorEl(event.currentTarget);
        setSelectedRow(rowData);
        setIsEditRowId(rowData?.id)
    };

    const handleEditTraceFee = (rowData) => {
        setIsEditable(true)

        handleMenuClose();

    };

    // Handle Menu Close
    const handleMenuClose = () => {
        setAnchorEl(null);
        // setSelectedRow(null);
    };

    const handleViewDocuments = () => {
        setAction("trace_document")
        handleMenuClose();
    };

    const handleUpdateTraceDetails = (id, name, newData) => {
        const formData = new FormData()

        formData.append("organisation_id", getOrganisationId())
        formData.append("id", name === "edit" ? id : selectedRow?.id)

        if (name === "edit") {
            formData.append("edit_trace_fee", "yes")
            formData.append("penalty_fee", newData?.trace_fee)
        } if (name === "received") {
            handleMenuClose();
            formData.append("mark_recived", "yes")

        } if (name === "not_received") {
            handleMenuClose();
            formData.append("mark_not_recived", "yes")

        }

        PartSalesServices.updateSubCoreTraceItem(formData).then((res) => {
            message.showToastMessage({
                message: "Trace Updated successfully.",
                variant: "success",
            });
            setIsRefreshTable(true)
            fetchData()
            getCoreTableDetails()
            setIsEditable(false)
        }).catch((res) => {
            setIsEditable(false)
            message.showToastMessage({ message: res.errors ? res.errors.join(', ') : "Something went wrong. Try again", variant: "error" });
        })


    };
    useEffect(() => {
        if (repairData.length > 0) {
            handleActions(repairData[0])
        }
    }, [repairData])


    const receiptColumns = [

        {
            title: "Receipt",
            field: "recept",
            cellStyle: {
                textAlign: "left",
                width: "45%",
                paddingLeft: "20px"

            },
            headerStyle: {
                textAlign: "left",
                width: "45%",
                paddingLeft: "20px"
            }
        },
        {
            title: "Due",
            field: "due",
            render: (rowData) => format24HrDateOnly(rowData?.due)
        },
        {
            title: "Received",
            field: "received",
            render: (rowData) => format24HrDateOnly(rowData?.received)
        },
        {
            title: "Late Days",
            field: "late_day"
        },
        {
            title: "Day Fee",
            field: "day_fee",
        },
        {
            title: "Late Fee",
            field: "late_fee",
        },
        {
            title: "Currency",
            field: "currency"
        },
        {
            title: "Action",
            field: "",
            render: (rowData) => <>{
                writePermission && rowData?.parent_status < 2 ? <IconButton onClick={() => {
                    setAction("repair")
                    setSelectedRow(rowData)
                }
                }>
                    <EditIcon fontSize='small' htmlColor={ICON_COLOUR} />
                </IconButton > : ""
            }</>
        }
    ]


    const traceColumns = [
        {
            title: "Code",
            field: "code",
            editable: "never",
            cellStyle: {
                textAlign: "left",

                paddingLeft: "20px"

            },
            headerStyle: {
                textAlign: "left",

                paddingLeft: "20px"
            }
        },
        {
            title: "Trace Requirement",
            field: "name",
            editable: "never",
            cellStyle: {
                textAlign: "left",
                width: "40%"

            },
            headerStyle: {
                textAlign: "left",
                width: "40%"
            }
        },
        {
            title: "Percentage",
            field: "percent",
            editable: "never",
            render: (rowData) => `${rowData.percent}%`
        },
        {
            title: "Value",
            field: "value",
            editable: "never",
        },
        {
            title: "Status",
            field: "status",
            editable: "never",
            render: (rowData) => renderStateIcon(rowData)

        },
        {
            title: "Trace Fee",
            field: "trace_fee",


        },
        {
            title: "Currency",
            field: "currency",
            editable: "never",
        },
        {
            title: "Action",
            field: "action",
            editable: "never",
            render: (rowData) =>

                <>
                    <IconButton onClick={(e) => {
                        handleMenuOpen(e, rowData)
                        setSelectedRow(rowData)

                    }}>
                        <MoreVertIcon />
                    </IconButton>

                    {anchorEl &&
                        <Menu id={`long-menu`}
                            anchorEl={anchorEl}
                            // keepMounted
                            open={Boolean(anchorEl)}
                            // className={classes.menu}
                            onClose={handleMenuClose}
                            getContentAnchorEl={null}
                            anchorOrigin={{ vertical: "top", horizontal: "left" }}
                            transformOrigin={{ horizontal: "left" }}
                            PaperProps={{
                                style: {
                                    maxHeight: 45 * 4,
                                    width: "25ch",
                                    fontSize: "13px"
                                },
                            }} >
                            <MenuItem onClick={handleViewDocuments}>Documents</MenuItem>
                            {canEditTraceFee && (
                                <MenuItem onClick={() => handleEditTraceFee(rowData)}>Edit Trace Fee</MenuItem>
                            )}

                            {canMarkReceived && (
                                <MenuItem onClick={() => handleUpdateTraceDetails(rowData?.id, "received")}>
                                    Mark Received
                                </MenuItem>
                            )}

                            {canMarkNotReceived && (
                                <MenuItem onClick={() => handleUpdateTraceDetails(rowData?.id, "not_received")}>
                                    Mark NOT Received
                                </MenuItem>
                            )}
                        </Menu>}
                </>

        },
    ];
    const handleActions = async (rowData) => {
        try {
            const response = await MaintenanceServices.getMaintOrderDetails(rowData?.id)
            if (response?.data) {

                setWorkshopOrderDetails(response?.data);
            }

        }
        catch {
        }


    }

    const repairColumns = [
        {
            title: 'Repair',
            field: 'repair',
            editable: "never",
            cellStyle: {
                textAlign: "left",

                paddingLeft: "20px"

            },
            headerStyle: {
                textAlign: "left",

                paddingLeft: "20px"
            }
        },
        {
            title: 'Order #',
            field: 'order',
            editable: "never",
            render: rowData => (
                <a style={{ textDecoration: "underline" }} onClick={() => {
                    setAction("viewCommerial");
                }}>
                    {rowData.order}
                </a>
            ),
        },
        {
            title: 'State',
            field: 'order_state',
            editable: "never",
        },
        {
            title: 'Quantity',
            field: 'quantity',
            type: 'numeric',
            editable: "never",
        },
        {
            title: 'Serial #',
            field: 'serial',
            editable: "never",
        },
        {
            title: 'Reports',
            field: 'reports',
            editable: "never",
            render: () => (
                <IconButton size="small" onClick={() => {
                    setAction("report")
                }}>
                    <VisibilityIcon htmlColor={ICON_COLOUR} fontSize={"small"} />
                </IconButton>
            ),
        },
        {
            title: 'Repair Fee',
            field: 'repair_fee',

        },
        {
            title: 'Currency',
            field: 'currency',
            editable: "never",
        },

    ];

    let tableOptions = {

        ...options,
        search: false,
        paging: false,
        toolbar: false,

    }
    const handleRepairUpdate = async (newData, rowData) => {

        const params = {
            organisation_id: getOrganisationId(),
            sales_core_id: currentSelection.id,
            repair_fee: newData?.repair_fee

        }
        await PartSalesServices.updateSubRepairTraceItem(params).then((res) => {
            if (res?.success) {
                message.showToastMessage({
                    message: "Updated successfully.",
                    variant: "success",
                });
                setIsRefreshTable(true)
                fetchData()
                getCoreTableDetails()
            }
            else {
                message.showToastMessage({ message: res.errors ? res.errors.join(', ') : "Something went wrong. Try again", variant: "error" });
            }

        }).catch((res) => {
            message.showToastMessage({ message: res.errors ? res.errors.join(', ') : "Something went wrong. Try again", variant: "error" });
        })

    }

    const tableConfigurations = [
        { data: data, columns: receiptColumns, name: "receipt" },
        {
            data: traceData, columns: traceColumns, name: "trace", editable: writePermission && isEditable && {
                isEditHidden: (rowData) => rowData?.id !== editingRowId || !writePermission,
                onRowUpdate: (newData, oldData) =>
                    new Promise((resolve) => {
                        handleUpdateTraceDetails(newData?.id, "edit", newData)
                        resolve();
                    }),
            },
        },
        {
            data: repairData, columns: repairColumns, name: "repair", editable: writePermission && parentState?.parent_status < 2 && {
                isEditHidden: (rowData) => !writePermission,
                onRowUpdate: (newData, oldData) =>
                    new Promise((resolve) => {

                        handleRepairUpdate(newData, oldData);
                        resolve();
                    }),
            },
        }
    ];

    const getReleaseDocuments = async (data) => {
        if (data.id) {

            const params = {
                workshop_order_id: data.id,
            };
            await MaintenanceServices.getReleaseDocument(params)
                .then((response) => {
                    setReleaseDocuments(response.data?.workshop_report)
                    // console.log("releasedocument", releaseDocuments)
                })
                .catch((err) => {
                    message.showToastMessage({
                        message: "Something went wrong. Try again!",
                        variant: "error",
                    });
                })
                .finally(() => {

                });
        }
    };

    return (
        <Box mt={"10px"}>
            {tab === "core" && <> <Typography color="primary" style={{ marginBottom: "10px" }}>
                Selected Item
            </Typography>
                <Typography variant='body1' style={{ marginBottom: "10px", fontSize: "12px" }}>
                    Select a Return Item in the table above to show details below
                </Typography></>}

            {tableConfigurations.map((config, index,) => (
                <div key={index}>
                    <MaterialTable
                        title=""
                        icons={tableIcons}
                        columns={
                            config.name === "trace" && isEditable
                                ? config.columns.filter((col) => col.field !== "action")
                                : config.columns
                        }
                        data={config.data}
                        options={tableOptions}

                        editable={config.editable}
                    />
                    {/* Spacing */}
                    <Box mb={2} />
                </div>
            ))}
            {action && action === "repair" && <Receipt
                handleClose={refreshTable}
                tab={"main"}
                id={currentSelection.id}
                currentSelection={selectedRow}
            />}
            {action && action === "trace_document" &&
                <TraceDocuments
                    handleClose={refreshTable}
                    id={currentSelection.id}
                    currentSelection={selectedRow}
                    open={true}
                    setIsRefreshTable={setIsRefreshTable}
                    writePermission={writePermission}
                />}
            {
                action && action === "viewCommerial" && (
                    <TabDetails
                        permission={props?.permission}
                        handleClose={refreshTable}
                        action={"Unlock"}
                        currentSelection={workshopOrderDetails}
                        tabId={20}
                        order_type={1}
                        setAction={setAction}
                        getMaintenanceOrderList={fetchData}
                        type={"dashboardCommercial"}
                    // paginationReset={paginationReset}
                    />
                )
            }
            {action === "report" && <Files handleClose={() => setAction(null)} name={"Workshop Order Reports"} currentSelection={releaseDocuments || []} />}
        </Box>
    )
}
